export const environment = {
  production: true,
  env: 'Desarrollo',
  ApiUrl: 'https://icamiapidev.clavisco.com/',
};
